<template>
  <EditItemForm :con="con" :editedItem="editedItem" @closed="close">
    <template v-slot:dialog-text="{ item }">
      <v-container>
        <v-row>
          <v-col cols="2"/>
          <v-col cols="4">
            <v-select
              v-model="item.categoryId"
              :items="categories" 
              item-value="id"
              item-text="name"
              :label="$t('crudCategories.hName')"
              :rules="rules.emptyField"
              required
              persistent-hint
              single-line
              color="grey"
            ></v-select>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="item.quantity"
              :label="$t('crudCategories.fieldQuantity')"
              :rules="rules.inputNumber"
              :suffix="$t('crudDesks.title')"
              color="grey"/>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </EditItemForm>
</template>

<script>
import EditItemForm from "../EditItemForm";
import rules from "@/models/InputRules";
import { mapGetters } from "vuex";

export default {
  name: "EditRoomForm",
  components: {
    EditItemForm,
  },
  props: {
    con: null,
    editedItem: null,
  },
  data: () => ({
    rules: rules,
  }),
  computed: {
    ...mapGetters('categorieModule', {categories: 'getCategories'})
  },
  methods: {
    close() {
      this.$emit("closed");
    },
  },
};
</script>
